module.exports = __webpack_public_path__ + "static/media/Artboard4.b2c500eb.png";